// Shared hooks exports

export {useModel} from "./state-management/use-model";
export {useModelScroll} from "./state-management/use-model-scroll";
export {useRouterBridge} from "./navigation/use-router-bridge";
export {useServerRouter} from "./navigation/use-server-router";

export {useDetectClickOutside} from "./dom/use-detect-click-outside";
export {useFloatingDropdown} from "./ui/use-floating-dropdown";
export {useMatchMedia} from "./dom/use-match-media";
export {useUpdateEffect} from "./effects/use-update-effect";
export {useLockedBody} from "./dom/use-locked-body";

export {useIntersection} from "./observers/use-intersection";
export {useVideoIntersection} from "./observers/use-video-intersection";
export type {UseIntersectionOptions, UseIntersectionCallbacks} from "./observers/use-intersection";
export type {UseVideoIntersectionOptions} from "./observers/use-video-intersection";
export type {ExpandableTextState, UseExpandableTextOptions, UseExpandableTextReturn} from "../ui/data-display/expandable-text/use-expandable-text";
